import Sorteo from "./sorteo";
import { useEffect, useState } from "react";


// const Sorteos = ({ data, logo, dataBoard }) => {
const Sorteos = ({ dataInfo }) => {
  // Estado para controlar la visibilidad del div
  const [isVisibleDinero, setIsVisibleDinero] = useState(false);
  const [contDinero, setContDinero] = useState(0);
  const [isVisibleProducto, setIsVisibleProducto] = useState(false);
  const [contProducto, setContProducto] = useState(0);
  const [isVisibleExpress, setIsVisibleExpress] = useState(false);
  const [contExpress, setContExpress] = useState(0);

  useEffect(()=>{
    setContDinero(dataInfo.data.dataSorteos.filter(sorteo => sorteo.typeLot === 'Dinero' && sorteo.estado !== 'archivado').length)
    setContProducto(dataInfo.data.dataSorteos.filter(sorteo => sorteo.typeLot === 'Producto' && sorteo.estado !== 'archivado').length)
    setContExpress(dataInfo.data.dataSorteos.filter(sorteo => sorteo.typeLot === 'Express' && sorteo.estado !== 'archivado').length)
  },[dataInfo.data.dataSorteos])
  // Función para alternar la visibilidad
  const toggleVisibility = (data) => {
    if(data === 'Dinero'){
        setIsVisibleDinero(!isVisibleDinero);
    }
    if(data === 'Producto'){
        setIsVisibleProducto(!isVisibleProducto)
    }
    if(data === 'Express'){
        setIsVisibleExpress(!isVisibleExpress)
    }
};
  return (
    <div className="sorteos">
      <h1>Sorteos Activos</h1>
      <div className="sorteoDinero">
        <div className={`contenedor-sorteos cols-3`}>
          <h1 onClick={()=>toggleVisibility('Dinero')} className={`toggle-title ${isVisibleDinero ? 'open' : ''}`}>
              sorteos de dinero {contDinero}
          </h1>
          {isVisibleDinero && (
            <div>
                {dataInfo.data.dataSorteos.map(sorteo => {
                    if (sorteo.typeLot === 'Dinero') {
                      if(sorteo.estado !== 'archivado'){
                        return <Sorteo key={sorteo.id} dataInfo={{...dataInfo,agregado:sorteo}} />;
                      }
                    }
                })}
            </div>
          )}
        </div>
      </div>
      <div className="sorteoProducto">
        <div className={`contenedor-sorteos cols-3`}>
          <h1 onClick={()=>toggleVisibility('Producto')} className={`toggle-title ${isVisibleProducto ? 'open' : ''}`}>
              sorteos de Producto {contProducto}
          </h1>
          {isVisibleProducto && (
            <div>
                {dataInfo.data.dataSorteos.map(sorteo => {
                    if (sorteo.typeLot === 'Producto') {
                      if(sorteo.estado !== 'archivado'){
                        return <Sorteo key={sorteo.id} dataInfo={{...dataInfo,agregado:sorteo}} />;
                      }
                    }
                })}
            </div>
          )}
        </div>
      </div>
      <div className="sorteoExpress">
        <div className={`contenedor-sorteos cols-3`}>
          <h1 onClick={()=>toggleVisibility('Express')} className={`toggle-title ${isVisibleExpress ? 'open' : ''}`}>
              sorteos Express {contExpress}
          </h1>
          {isVisibleExpress && (
            <div>
                {dataInfo.data.dataSorteos.map(sorteo => {
                    if (sorteo.typeLot === 'Express') {
                      if(sorteo.estado !== 'archivado'){
                        return <Sorteo key={sorteo.id} dataInfo={{...dataInfo,agregado:sorteo}} />;
                      }
                    }
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sorteos;